<template>
	<div v-show="orderStatus !=null?true:false">
		<tSearch></tSearch>
		<div class="main">
			<div class="main_nav">
				<ul class="text d-rn d-aic d-jcs">
					<li class="showHand" @click="handleReturnMyInfo">订单详情</li>
					<li>></li>
					<li style="color: #333333;">订单：{{orderCodeId||''}}</li>
				</ul>
				<p class="line"></p>
				<ul class="statuslist">
					<!-- 待付款 -->
					<li v-if="orderStatus==1">
						<div class="left">
							<p class="waitPay">等待付款</p>
							<p class="countDown">剩余0时{{timeNum>0?timeNum:''}}分</p>
							<p class="confirm showHand" @click="throttle(handleLjFkBtn,1500)">付款</p>
							<p class="editAdd showHand" @click="ModifyAddress">修改地址</p>
							<p class="cancelOrder showHand" @click="throttle(handleCloseOrder,1500)">取消订单</p>
						</div>
						<ul class="oneright">
							<li class="oneright_top">该订单会为您保留30分钟（从下单之时算起），30分钟后如果还未付款，系统将自动取消该订单。</li>
							<ul class="oneright_nav">
								<li class="proStatus">
									<img src="../../assets/img/privacy/edit.png">
									<p>提交订单</p>
									<p>{{sonOrderPriceInfo && sonOrderPriceInfo.backCreateTime?
									sonOrderPriceInfo.backCreateTime.slice(0,10):''}}</p>
									<p>{{sonOrderPriceInfo && sonOrderPriceInfo.backCreateTime?
									sonOrderPriceInfo.backCreateTime.slice(11):''}}</p>
								</li>
								<img src="../../assets/img/privacy/waitspot.png" class="spot">
								<li class="proStatus">
									<img src="../../assets/img/privacy/fail.png">
									<p class="nine">付款成功</p>
								</li>
								<img src="../../assets/img/privacy/nospot.png" class="spot">
								<li class="proStatus">
									<img src="../../assets/img/privacy/waitGoods.png">
									<p class="nine">等待收货</p>
								</li>
								<img src="../../assets/img/privacy/nospot.png" class="spot">
								<li class="proStatus">
									<img src="../../assets/img/privacy/complete.png">
									<p class="nine">已完成</p>
								</li>
							</ul>
						</ul>
					</li>
					<!-- 待生产 -->
					<li v-if="orderStatus==2">
						<div class="left">
							<p class="waitPay">待生产</p>
							<p class="showHand" @click="handleTipsTxt">催促发货</p>
						</div>
						<ul class="right">
							<li class="proStatus">
								<img src="../../assets/img/privacy/edit.png">
								<p>提交订单</p>
							</li>
							<img src="../../assets/img/privacy/spot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/success.png">
								<p>付款成功</p>
							</li>
							<img src="../../assets/img/privacy/waitspot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/waitGoods.png">
								<p class="nine">等待收货</p>
							</li>
							<img src="../../assets/img/privacy/nospot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/complete.png">
								<p class="nine">已完成</p>
							</li>
						</ul>
					</li>
					<!-- 生产中 -->
					<li v-if="orderStatus==3">
						<div class="left">
							<p class="waitPay">生产中</p>
							<p class="showHand" @click="handleTipsTxt">催促发货</p>
						</div>
						<ul class="right">
							<li class="proStatus">
								<img src="../../assets/img/privacy/edit.png">
								<p>提交订单</p>
							</li>
							<img src="../../assets/img/privacy/spot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/success.png">
								<p>付款成功</p>
							</li>
							<img src="../../assets/img/privacy/waitspot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/waitGoods.png">
								<p class="nine">等待收货</p>
							</li>
							<img src="../../assets/img/privacy/nospot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/complete.png">
								<p class="nine">已完成</p>
							</li>
						</ul>
					</li>
					<!-- 待收货 -->
					<li v-if="orderStatus==4">
						<div class="left">
							<p class="waitPay">等待收货</p>
							<p class="confirm_nav showHand" @click="handleReceivGoods">确认收货</p>
						</div>
						<ul class="right">
							<li class="proStatus">
								<img src="../../assets/img/privacy/edit.png">
								<p>提交订单</p>
							</li>
							<img src="../../assets/img/privacy/spot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/success.png">
								<p>付款成功</p>
							</li>
							<img src="../../assets/img/privacy/spot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/redComplete.png">
								<p>等待收货</p>
							</li>
							<img src="../../assets/img/privacy/waitspot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/complete.png">
								<p class="nine">已完成</p>
							</li>
						</ul>
					</li>
					<!-- 已完成 -->
					<li v-if="orderStatus==5">
						<div class="left">
							<p class="waitPay">已经完成</p>
							<p class="showHand" @click="throttle(handleDelOrderInfo,1500)">删除订单</p>
						</div>
						<ul class="right">
							<li class="proStatus">
								<img src="../../assets/img/privacy/edit.png">
								<p>提交订单</p>
							</li>
							<img src="../../assets/img/privacy/spot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/success.png">
								<p>付款成功</p>
							</li>
							<img src="../../assets/img/privacy/spot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/redComplete.png">
								<p>等待收货</p>
							</li>
							<img src="../../assets/img/privacy/spot.png" class="spot">
							<li class="proStatus">
								<img src="../../assets/img/privacy/redComplete.png">
								<p>已完成</p>
							</li>
						</ul>
					</li>
				</ul>
				
				<!-- 商品列表 -->
				<!-- 待付款 -->
				<div class="productlist" v-if="orderStatus==1">
					<div class="producttop">
						<ul class="proMenu1">
							<li>商品信息</li>
							<li>商品数量</li>
							<li>订单编号</li>
							<li>创建时间</li>
						</ul>
						<ul class="proMenuList d-rn d-aic d-jcs" v-for="(item,index) in orderSonAllType==1?crtPageOrderInfo:crtPageAllOrderInfo" :key="index">
							<li class="firstLi1">
								<img :src="item.goods_attr_img">
								<p class="proDetailNav txt-cuts">{{item.goods_title}}</p>
							</li>
							<li class="num1 one-txt-cut">{{item.back_num}}</li>
							<li class="orderNum1 one-txt-cut">{{item.back_number}}</li>
							<li class="createTime1 one-txt-cut">{{item.back_create_time}}</li>
						</ul>
					</div>
					<ul class="productbot">
						<li>
							<p>商品总额：</p>
							<p class="rgtTxtMinWid">￥{{orderSonAllType==1 && allShopPrice?allShopPrice:
							orderSonAllType==0&& allOrderPriceInfo && allOrderPriceInfo.orderSum?allOrderPriceInfo.orderSum:'0.00'}}</p>
						</li>
						<li>
							<p>运费：</p>
							<p class="rgtTxtMinWid">￥{{orderSonAllType==1 && sonOrderPriceInfo && sonOrderPriceInfo.backFreight?sonOrderPriceInfo.backFreight:
							orderSonAllType==0&& allOrderPriceInfo &&allOrderPriceInfo.orderFreight?allOrderPriceInfo.orderFreight.toFixed(2):'0.00'}}</p>
						</li>
						<li>
							<p>优惠券：</p>
							<p class="rgtTxtMinWid">￥{{orderSonAllType==1 && sonOrderPriceInfo &&sonOrderPriceInfo.backDiscountAmount?sonOrderPriceInfo.backDiscountAmount:
							orderSonAllType==0&& allCoupupInfo &&allCoupupInfo.couponAmount?allCoupupInfo.couponAmount:'0.00'}}</p>
						</li>
						<li class="productbot_last">
							<p>实付款：</p>
							<p class="rgtTxtMinWid">￥{{orderSonAllType==1 && sonOrderPriceInfo &&sonOrderPriceInfo.backPayPaidMoney?sonOrderPriceInfo.backPayPaidMoney:
							orderSonAllType==0&& allOrderPriceInfo && allOrderPriceInfo.orderCouponSum?allOrderPriceInfo.orderCouponSum:'0.00'}}</p>
						</li>
					</ul>
				</div>
				<!-- 其他类型 -->
				<div class="productlist" v-else>
					<div class="producttop">
						<ul class="proMenu">
							<li>商品信息</li>
							<li>商品数量</li>
							<li>订单编号</li>
							<li>创建时间</li>
							<li>支付方式</li>
						</ul>
						<ul class="proMenuList d-rn d-aic d-jcs" 
						v-for="(item,index) in orderSonAllType==1?crtPageOrderInfo:crtPageAllOrderInfo" :key="index">
							<li class="firstLi">
								<img :src="item.goods_img">
								<p class="proDetailNav txt-cuts">{{item.goods_title}}</p>
							</li>
							<li class="num one-txt-cut">{{item.back_num}}</li>
							<li class="orderNum one-txt-cut">{{item.back_number}}</li>
							<li class="createTime one-txt-cut">{{item.back_create_time}}</li>
							<li class="payType one-txt-cut" style="flex: 1;text-align: left;">{{item.back_pay_type==2?'支付宝支付':'微信支付'}}</li>
							<!-- 子订单按钮 -->
							<template v-if="orderSonAllType==1">
								<p class="showHand evaluation-order" v-if="!z_UserComments" @click="throttle(evaluationOrder,1500,item)">评价商品</p>
							</template>
							<!-- 总订单按钮 -->
							<template v-else>
								<p class="showHand evaluation-order" v-if="!item.UserComments" @click="throttle(evaluationOrder,1500,item)">评价商品</p>
							</template>
						</ul>
					</div>
					<ul class="productbot" >
						<li>
							<p>商品总额：</p>
							<p class="rgtTxtMinWid">￥{{orderSonAllType==1 && allShopPrice?allShopPrice:
							orderSonAllType==0&& allOrderPriceInfo && allOrderPriceInfo.orderSum?allOrderPriceInfo.orderSum:'0.00'}}</p>
						</li>
						<li>
							<p>运费：</p>
							<p class="rgtTxtMinWid">￥{{orderSonAllType==1 && sonOrderPriceInfo && sonOrderPriceInfo.backFreight?sonOrderPriceInfo.backFreight:
							orderSonAllType==0&& allOrderPriceInfo &&allOrderPriceInfo.orderFreight?allOrderPriceInfo.orderFreight.toFixed(2):'0.00'}}</p>
						</li>
						<li>
							<p>优惠券：</p>
							<p class="rgtTxtMinWid">￥{{orderSonAllType==1 && sonOrderPriceInfo &&sonOrderPriceInfo.backDiscountAmount?sonOrderPriceInfo.backDiscountAmount:
							orderSonAllType==0&& allCoupupInfo &&allCoupupInfo.couponAmount?allCoupupInfo.couponAmount:'0.00'}}</p>
						</li>
						<li class="productbot_last">
							<p>实付款：</p>
							<p class="rgtTxtMinWid">￥{{orderSonAllType==1 && sonOrderPriceInfo &&sonOrderPriceInfo.backPayPaidMoney?sonOrderPriceInfo.backPayPaidMoney:
							orderSonAllType==0&& allOrderPriceInfo && allOrderPriceInfo.orderCouponSum?allOrderPriceInfo.orderCouponSum:'0.00'}}</p>
						</li>
					</ul>
				</div>
				
				
				
				
				<!-- 收货人信息 -->
				<div class="memberlist">
					<p>收货人信息</p>
					<ul class="memberlist_nav">
						<li class="one-txt-cut">
							收货人：{{shAddressInfo?shAddressInfo.addrName:''}}
						</li>
						<li class="one-txt-cut">
							手机号码：{{shAddressInfo?shAddressInfo.addrPhone:''}}
						</li>
						<li class="one-txt-cut">
							公司名称：{{shAddressInfo?shAddressInfo.addrCompany:''}}
						</li>
					</ul>
					<ul class="memberlist_nav address">
						<li style="width: 100%;">收货地址：{{shAddressInfo?shAddressInfo.addrProvince:''}}{{shAddressInfo?shAddressInfo.addrMarket:''}}
						{{shAddressInfo?shAddressInfo.addrCounty:''}}{{shAddressInfo?shAddressInfo.addrAddress:''}}</li>
					</ul>
				</div>
				<!-- 物流信息  -->
				<div class="logisticsImg" v-if="(orderStatus==4 || orderStatus==5) && wxDisplayNum==3">
					<p class="logisticsImgPone">物流信息</p>
					<ul :class="[index==newWlInfo.length-1?'orMarTop40':'','logisticsImgUl','d-rn','d-aic','d-jcs']" v-for="(item,index) in newWlInfo" :key='index'>
						<!-- 左 -->
						<li class="logisticsImgUlLft d-cw d-aic d-jcc">
							<p>
								{{item.riqiTime}}
							</p>
							<p>
								{{item.shifenTime}}
							</p>
						</li>
						<!-- 中 -->
						<li class="logisticsImgUlCon">
							<!-- 发货 -->
							<img src="../../assets/img/comm/icon_faHuoImg.png" v-if="index==newWlInfo.length-1">
							<!-- 竖线 -->
							<p class="logisticsImgUlConP  d-cw d-aic d-jcs" v-else>
								<!-- 圆 -->
								<span></span>
								<!-- 竖 -->
								<span></span>
							</p>
						</li>
						<!-- 右 -->
						<li class="logisticsImgUlRgt">
							{{item.context}}
						</li>
					</ul>
				</div>
				<!-- 物流图片 -->
				<div class="logisticsImg d-cw d-ais d-jcs" v-else-if="(orderStatus==4 || orderStatus==5) && wxDisplayNum==1">
					<p class="logisticsImgPone">物流信息</p>
					<p class="logisticsImgPtwo">
						<img :src="wxInfoImg" >
					</p>
				</div>
				<!-- 物流图片 -->
				<div class="logisticsImg d-rn d-aic d-jcc" style="padding: 0 !important;height: 100px !important;
				font-size: 20px;color: #666;" v-else-if="(orderStatus==4 || orderStatus==5)">
					暂无物流信息
				</div>
			</div>
		</div>
		
		<!-- 弹框修改地址 -->
		<div class="Maddress" v-show="MaddressStatus">
			<div class="Maddress_nav">
				<div class="Maddress_nav_top">
					<p>修改地址</p>
					<img src="../../assets/img/comm/icon_cha.png" @click="handleClosePupop" class="showHand">
				</div>
				<p class="mtitle">修改收货地址</p>
				<ul class="addDetail">
					<li class="li_top">
						<p style="font-size: 16px;color: #999999;">当前配送至</p>
						<p class="li_top_add">中国大陆</p>
					</li>
					<ul class="form">
						<li>
							<p>
								<span style="font-size: 16px;color: #FF0000;">*</span>
								<p>地址信息</p>
							</p>
							<p @click="pickerVisible = true" class="alert">
							<!-- {{addssTxt?addssTxt:'请选择省/市/区/街道'}} -->
							{{addssTxt?addssTxt:updateAddress&&updateAddress.location && updateAddress.locationyi&& updateAddress.locationer ?
								updateAddress.location+updateAddress.locationyi+updateAddress.locationer:'请选择省/市/区/街道'}}
							</p>
						</li>
						<li>
							<p><span class="minput">*</span>
							<p>详细地址</p>
							</p>
							<textarea v-model="updateAddress.detailaddress"
								placeholder="请输入详细地址信息,如道路/门牌号/小区/楼栋号/单元等信息"></textarea>
						</li>
						<li>
							<p><span class="minput">*</span>
							<p>公司名称</p>
							</p>
							<input type="" name="" id="" v-model="updateAddress.company" value=""
								placeholder="请输入公司名称" />
						</li>
						<li>
							<p><span class="minput">*</span>
							<p>收货人姓名</p>
							</p>
							<input type="" name="" id="" v-model="updateAddress.name" value=""
								placeholder="长度不超过25字符" />
						</li>
						<li>
							<p><span class="minput">*</span>
							<p>手机号码</p>
							</p>
							<input type="number" name="" v-model="updateAddress.phone" id="" value=""
								placeholder="请输入手机号码" />
						</li>
					</ul>
					<li class="lastli">
						<img :src="updateAddress&&updateAddress.status?require('../../assets/img/privacy/addressSelected.png')
						:require('../../assets/img/privacy/addressSelect.png')" class="choice" @click="selectStatus">
						<p class="mselect">设置为默认收货地址</p>
					</li>
					<button type="button" class="showHand" @click="throttle(handleBcEve,1500)">保存</button>
				</ul>
			</div>
		</div>
		<VuePicker :data="pickData" :layer="3" :showToolbar="true" @cancel="cancel" @confirm="confirm"
			:visible.sync="pickerVisible" />
	</div>
</template>
<script>
	import { 
		appUserFindByOrerInfo,				//总订单
		appUserFindByBackstageInfo,			//子订单
		appUserByBackstageOrOrder,			//判断子订单还是总订单
		appCBackstageAndOrderUpAddres,		//订单地址修改接口
		findLogistics,//物流信息
	} from '@/api/order.js'
	import { addAppCAddress,upAppCAddress } from '@/api/address.js'
	let timer;
	let _self;
	import {
		appUserFindByOrderList,	//查询全部
		// cancelOrder,		//取消订单
		appCBackstageCancel,	//取消子订单
		appCBackstageFinish,	//确认收货
		appCBackstageDelByBackId,//删除订单
	} from '@/api/allOrder.js'
	import wuliuArr from '../../assets/js/wuliuInfo.js'
	import tSearch from "@/components/tSearch.vue"
	import selAddress from "../../components/selAddress.vue"
	import { fileUpload,appCUserFindById } from '@/api/comm.js'
	import VuePicker from 'vue-pickers'
	import cityData from 'vue-pickers/city-data.js'
	const deepFreeze = function(obj) {
		var propNames = Object.getOwnPropertyNames(obj);
		propNames.forEach(function(name) {
			var prop = obj[name];
			if (typeof prop == 'object' && prop !== null) {
				deepFreeze(prop);
			}
		})
		return Object.freeze(obj)
	}
	// 冻结以提升性能
	const freezeCityData = deepFreeze(cityData)
	export default {
		components: {
			selAddress,
			VuePicker,
			// 引入搜索组件
			tSearch
		},
		data() {
			return {
				// 用户信息
				userInfo:null,
				showToolbar: true,
				pickerVisible: false,
				pickData: freezeCityData,
				result: '',
				// 显示的地址
				addssTxt: '',
				// 默认显示的地址
				updateAddress: {
					location: null,
					locationyi:null,
					locationer:null,
					detailaddress: null,
					name: null,
					phone: null,
					company: null,
					status:0,
				},
				// 修改地址状态
				MaddressStatus: false,
				message: '显示',
				
				
				// 物流信息
				newWlInfo:null,
				// 物流图片
				wxInfoImg:null,
				// 物流显示状态
				wxDisplayNum:0,
				
				
				
				// 订单类型==0总订单1子订单
				orderSonAllType:null,
				// 上个页面的信息==订单ID
				prevPageInfo:null,
				// 订单状态显示===1待付款2代生产3生产中4待收货5已完成
				orderStatus: null,
				// 子订单id
				orderSonID:null,
				// 总订单ID
				orderAllID:null,
				// 取消订单的id
				delOrderBackId:null,
				// 收货地址信息
				shAddressInfo:null,
				// 订单号
				orderCodeId:null,
				// 提示催促状态
				tipsState:false,
				
				// 子订单商品信息
				crtPageOrderInfo:null,
				// 子订单支付金额信息
				sonOrderPriceInfo:null,
				
				// 商品总金额
				allShopPrice:null,
				// 总订单商品信息
				crtPageAllOrderInfo:null,
				// 优惠券信息
				allCoupupInfo:null,
				// 总订单支付金额信息
				allOrderPriceInfo:null,
				// 倒计时
				timeNum: null,
				
				// 是否评价子订单
				z_UserComments:false,
			}
		},
		created() {
			_self = this;
			this.$EventBus.$emit('AppCloseNav', true);
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// 更新用户信息
			_self.handleUpdateUserInfo();
			
			
			// 判断页面传参信息
			try{
				// 解码获取的路由参数
				let pageVal=decodeURIComponent(_self.$router.history.current.query.id);
				// json化数据
				let jxVal=JSON.parse(pageVal || '{}');
				
				// 判断页面是否有传值信息
				if(pageVal && jxVal && jxVal.back_id){
					// console.log('上个页面的订单信息====',jxVal);
					
					// 定义当前页面类型
					_self.orderStatus=jxVal.back_status==0?2:
					jxVal.back_status==1?3:jxVal.back_status==3?5:
					jxVal.back_status==5?4:jxVal.back_status==7?1:null;
					// 定义上个商品信息
					_self.prevPageInfo=jxVal;
					// 定义===子订单id
					_self.orderSonID=jxVal.back_id;
					// 定义===总订单id
					_self.orderAllID=jxVal.order_id;
					// 判断订单类型
					_self.handleJudgeOrderType();
					// 查询物流信息
					if(_self.orderStatus==4 || _self.orderStatus==5){
						_self.handleCxWxInfo();
					}
				}else{
					_self.$eror('订单信息有误1！');
					// 无页面传值===返回上一页
					_self.$router.replace({name:'MyInfo'})
				}
			}catch(err){
				_self.$eror('订单信息有误2！');
				// 出现错误的情况下===》返回上一页
				_self.$router.replace({name:'MyInfo'})
			}
		},
		mounted() {
			
		},
		methods: {
			//确认收货===
			handleReceivGoods(){
				// console.log('backId==',_self.delOrderBackId);
				// 防止频繁请求
				if(_self.tipsState){
					_self.$jgTips('正在请求中，请稍等！')
					return false;
				}
				_self.tipsState=true;
				
				// 确认收货接口请求
				appCBackstageFinish({
					backId:_self.delOrderBackId,
					userId:_self.userInfo.id
				}).then(res=>{
					// console.log('确认收货接口返回值===',res);
					if(res.code==200){
						_self.$message({
							message:'确认收货成功！',
							type:'success'
						});
						// 返回上一页面
						_self.$router.replace({name:'MyInfo'})
					}
				}).finally(err=>{
					_self.isRsState=false;
				})
			},
			// 删除订单
			handleDelOrderInfo(){
				// 防止频繁请求
				if(_self.tipsState){
					_self.$jgTips('正在请求中，请稍等！')
					return false;
				}
				_self.tipsState=true;
				
				// 删除订单接口
				appCBackstageDelByBackId({
					backId:_self.delOrderBackId,
					userId:_self.userInfo.id
				}).then(res=>{
					// console.log('确认收货接口返回值===',res);
					if(res.code==200){
						_self.$message({
							message:'订单删除成功！',
							type:'success'
						});
						// 返回上一页面
						_self.$router.replace({name:'MyInfo'})
					}
				}).finally(err=>{
					_self.isRsState=false;
				})
			},
			// 查询物流信息
			async handleCxWxInfo(){
				findLogistics({
					orderId:_self.orderAllID
				}).then(res=>{
					console.log('物流信息===',res);
					if(res.code==200 && res.data){
						// 定义===物流显示信息
						
						// 定义物流格式
						_self.wxDisplayNum=res.data.newcode || 3;
						if(res.data.newcode==0 ){
							// 物流信息
							
							if(res.data.data &&res.data.data.length){
								// 定义物流信息
								_self.handleEditWlInfo(res.data.data).then(eee=>{
									_self.$set(_self,'newWlInfo',eee);
								});
							}
						}else if(res.data.newcode==1){
							// 物流图片
							_self.$set(_self,'wxInfoImg',res.data.data);
						}
					}
				})
			},
			
			// 返回我的订单页面
			handleReturnMyInfo(){
				this.$router.replace({name:'MyInfo'})
			},
			// 更新用户信息
			handleUpdateUserInfo(){
				appCUserFindById({
					userId:_self.userInfo.userId
				}).then(tes=>{
					if(tes.code==200){
						// 接口获取成功
						//定义本地存储的userInfo
						localStorage.setItem('userInfo',JSON.stringify(tes.data))
						// 传递给topBar==用户信息
						_self.$EventBus.$emit('userEditInfo',tes.data)
						// 定义当前用户信息
						_self.$set(_self,'userInfo',tes.data)
					}
				})
			},
			// 判断订单类型
			handleJudgeOrderType(){
				// 判断订单类型
				appUserByBackstageOrOrder({
					backId:_self.orderSonID
				}).then(res=>{
					// console.log('判断订单类型====',res);
					if(res.code==200){
						// 定义当前订单类型
						_self.orderSonAllType=res.data;
						
						// 判断订单类型
						if(res.data==1){
							// 子订单
							_self.handleGetOrderSonInfo();
						}else if(res.data==0){
							// 总订单
							_self.handleGetOrderAllInfo();
						}
					}
				})
			},
			// 获取子订单===详情
			handleGetOrderSonInfo(){
				// 订单信息===接口
				appUserFindByBackstageInfo({
					backId:_self.orderSonID
				}).then(res=>{
					console.log('子====订单信息===',res);
					if(res.code==200){
						// 当前订单是否评价
						_self.z_UserComments = res.data.UserComments
						// 订单当前页面订单信息
						_self.crtPageOrderInfo=res.data.goods;
						// 定义总订单id
						_self.orderCodeId=res.data.orderBackInfo.orderId;
						// 定义取消订单的ID
						_self.delOrderBackId=res.data.orderBackInfo.backId;
						
						
						// 定义商品总金额
						if(res.data.goods && res.data.goods.length){
							// 定义初始价格
							let csPrice='';
							// 循环商品列表
							res.data.goods.forEach((itt,ixx)=>{
								// 定义总价格
								
								if(!ixx){
									csPrice=itt.trader_goods_money*100*itt.back_num
								}else{
									csPrice=csPrice+itt.trader_goods_money*100*itt.back_num
								}
							})
							// console.log('总金额===',csPrice);
							// 定义显示的总价格
							_self.allShopPrice=csPrice?(csPrice/100).toFixed(2):'0.00';
						}
						// 定义收货地址信息
						_self.shAddressInfo=res.data.address;
						// 定义子订单价格信息
						_self.sonOrderPriceInfo=res.data.orderBackInfo;
						
						// 定义修改地址弹窗
						let xsAddss={};
						xsAddss.location=res.data.address.addrProvince;//省
						xsAddss.locationyi=res.data.address.addrMarket;//市
						xsAddss.locationer=res.data.address.addrCounty;//区
						xsAddss.detailaddress=res.data.address.addrAddress;//详细地址
						xsAddss.name=res.data.address.addrName;//收货人
						xsAddss.phone=res.data.address.addrPhone;//手机号
						xsAddss.company=res.data.address.addrCompany;//公司
						xsAddss.status=res.data.address.addrStatus;//公司
						_self.$set(_self,'updateAddress',xsAddss);
						// console.log('显示的地址信息====',_self.updateAddress);
						// 计算剩余时间
						_self.handleDownTimeJs(res.data.orderBackInfo.backCreateTime);
					}
				})
			},
			// 获取总订单===详情
			handleGetOrderAllInfo(){
				// 总订单详情接口
				appUserFindByOrerInfo({
					orderId:_self.orderAllID
				}).then(res=>{
					console.log('总====订单信息===',res);
					
					// 定义总订单id
					_self.orderCodeId=res.data.orderInfo.orderId;
					// 定义商品信息
					_self.crtPageAllOrderInfo=res.data.goods;
					// 定义收货地址信息
					_self.shAddressInfo=res.data.address;
					// 定义优惠券信息
					_self.allCoupupInfo=res.data.coupon;
					// 定义价格信息
					_self.allOrderPriceInfo=res.data.orderInfo;
					
					// 计算剩余时间
					_self.handleDownTimeJs(res.data.orderInfo.orderCreateTime);
				})
			},
			// 时间处理
			handleDownTimeJs(startTime){
				// console.log('接受到的时间==',startTime);
				try{
					//非待付款阻止定时
					if(_self.orderStatus!=1)return;
					// 开始时间====毫秒时间戳
					let orderStart=new Date(startTime).getTime();
					// 定义结束时间===毫秒时间戳
					let orderEnd=orderStart+30*1000*60;
					// 当前时间
					let currentTime=new Date().getTime();
					// 查看时间差
					let timeCha=_self.$commonFun.setTimeStamp(orderEnd-currentTime);
					// 定义倒计时显示的时间
					_self.timeNum=timeCha[2];
					
					//清除定时
					timer && clearInterval(timer);
					// 创建定时
					timer = setInterval(() => {
						// 获取当前时间
						let currentTime=new Date().getTime();
						// 查看时间差
						let MtimeCha=_self.$commonFun.setTimeStamp(orderEnd-currentTime);
						// console.log('定时器中的倒计时',MtimeCha);
						
						
						// 判断时间
						if (MtimeCha[2]<0||MtimeCha[2]==0) {
							// 定时结束===清除定时跳回首页
							clearInterval(timer);
							_self.$router.push('/')
						} else {
							// 定义时间
							_self.timeNum=MtimeCha[2];
						}
					}, 5000)
				}catch(err){
					clearInterval(timer);
					_self.$router.push('/')
				}
			},
			// 付款按钮
			handleLjFkBtn(){
				// console.log('订单信息===',it);
				
				
				let requestNeedData={
					orderInfdo:'',
					pagesId:_self.delOrderBackId
				}
				// console.log('页面传递==信息',requestNeedData);
				// 编码encodeURIComponent() ||  解码decodeURIComponent()
				let pageVal=encodeURIComponent(JSON.stringify(requestNeedData));
				// 不保存当前页面跳转==传递下一页信息
				_self.$router.replace({name:'orderXq',query:{info:pageVal}})
			},
			
			
			// 取消订单
			handleCloseOrder(){
				// orderCodeId
				
				// 防止频繁请求
				if(_self.tipsState){
					_self.$jgTips('正在请求中，请稍等！')
					return false;
				}
				_self.tipsState=true;
				
				// 取消订单接口
				appCBackstageCancel({
					backId:_self.delOrderBackId
				}).then(res=>{
					if(res.code==200){
						// 提示成功
						_self.$message({
							message:'取消成功',
							type:'success'
						});
						// 返回上一页
						_self.$router.replace({name:'MyInfo'})
					}
				}).finally(err=>{
					_self.tipsState=false;
				})
			},
			
			
			
			
			
			
			
			
			
			
			
			// 反馈提醒
			handleTipsTxt(){
				// 组织频繁请求
				if(_self.tipsState){
					_self.$jgTips('请勿频繁点击！');
					return false;
				}
				_self.tipsState=true;
				
				// 提示催促成功
				_self.$message({
					message:'已成功催促商家！',
					type:'success'
				});
				setTimeout(()=>{
					// 允许再次提示
					_self.tipsState=false;
				},3000)
			},
			
			
			
			
			
			// 物流信息处理
			handleEditWlInfo(val){
				return new Promise((resolve,reject)=>{
					// 非数组数组   非空
					if(!val || val && !val.length){
						return reject(false)
					};
					// 处理数组的日期(月日)和时间(时分)
					val.forEach((it,ix)=>{
						it.riqiTime=it.ftime.slice(5,10);
						it.shifenTime=it.ftime.slice(11,16);
					})
					return resolve(val);
				})
				
				
				
				
			},
			// 改变地址的选中
			selectStatus() {
				// 选中状态取反
				_self.updateAddress.status = _self.updateAddress.status?false:true;
				// 强制刷新
				this.$forceUpdate()
			},
			// 修改地址===打开地址弹窗
			ModifyAddress() {
				
				// 状态取反
				_self.MaddressStatus = !_self.MaddressStatus;
				
				// 定义显隐提示语
				if (_self.MaddressStatus) {
					_self.message = '隐藏'
				} else {
					_self.message = '显示'
				}
			},
			// 地址弹窗===保存事件
			handleBcEve(){
				// 走地址新增===
				// console.log('重新选择的地址信息===',_self.updateAddress);
				// 判断是否选择地址																						  
				if(!_self.addssTxt || _self.updateAddress &&!_self.updateAddress.location || _self.updateAddress &&!_self.updateAddress.locationyi
				|| _self.updateAddress &&!_self.updateAddress.locationer){
					_self.$jgTips('请选择地址！');
					return false;
				}
				// 详细地址
				if(_self.updateAddress && !_self.updateAddress.detailaddress){
					_self.$jgTips('请输入详细地址！');
					return false;
				}
				// 公司名称
				if(_self.updateAddress && !_self.updateAddress.company){
					_self.$jgTips('请输入公司名称！');
					return false;
				}
				// 收货人姓名
				if(_self.updateAddress && !_self.updateAddress.name){
					_self.$jgTips('请输入收货人姓名！');
					return false;
				}
				// 手机号
				if(_self.updateAddress && !_self.updateAddress.phone){
					_self.$jgTips('请输入正确的手机号码！');
					return false;
				}
				
				// 订单地址ID修改
				let adsInfo={							
					addrProvince:_self.updateAddress.location,//省
					addrMarket:_self.updateAddress.locationyi,//市
					addrCounty:_self.updateAddress.locationer,//区
					addrAddress:_self.updateAddress.detailaddress,//详细地址
					addrCompany:_self.updateAddress.company,//公司名称
					userId:_self.userInfo.userId,//用户ID
					addrName:_self.updateAddress.name,//收货人
					addrPhone:_self.updateAddress.phone,//联系方式
					addrStatus:_self.isDefaultAds?2:0,//默认地址
				}
				
				// 防止频繁请求
				if(_self.tipsState){
					_self.$jgTips('正在请求中，请稍等！')
					return false;
				}
				_self.tipsState=true;
				
				
				// 地址新增接口
				addAppCAddress(adsInfo).then(res=>{
					// console.log('新增接口请求====成功',res);
					if(res.code==200){
						// 走订单地址修改接口
						appCBackstageAndOrderUpAddres({
							backId:_self.sonOrderPriceInfo.backId,
							addrId:res.data.addrId,
						}).then(tes=>{
							// console.log('地址修改成功===',tes);
							
							// 提示修改成功
							_self.$message({
								message:'地址修改成功！',
								type:'success'
							});
							// 关闭当前弹窗
							_self.handleClosePupop();
							
							// 重新走详情接口===判断订单类型
							if(_self.orderSonAllType==1){
								// 子订单
								_self.handleGetOrderSonInfo();
							}else if(_self.orderSonAllType==0){
								// 总订单
								_self.handleGetOrderAllInfo();
							}
						}).finally(err=>{
							// 允许再次请求
							_self.tipsState=false;
						})
					}
				}).catch(err=>{
					// 允许再次请求
					_self.tipsState=false;
				})
			},
			// 关闭地址弹窗
			handleClosePupop() {
				// 关闭弹窗
				_self.MaddressStatus = false;
				
				// 清空data地址弹窗信息
				_self.addssTxt = null;
				_self.$set(_self,'updateAddress',{
					location: _self.shAddressInfo.addrProvince,
					locationyi:_self.shAddressInfo.addrMarket,
					locationer:_self.shAddressInfo.addrCounty,
					detailaddress: _self.shAddressInfo.addrAddress,
					name: _self.shAddressInfo.addrName,
					phone: _self.shAddressInfo.addrPhone,
					company: _self.shAddressInfo.addrCompany,
					status:_self.shAddressInfo.addrStatus,
				});
			},
			// 地址选择器===关闭、打开
			cancel() {
				this.result = '';
				this.addssTxt = '';
			},
			// 地址选择器===确定事件
			confirm(res) {
				let obj = JSON.parse(JSON.stringify(res))
				if (obj[0].children) {
					delete obj[0].children
				}
				if (obj[1].children) {
					delete obj[1].children
				}
				if (obj[2].children) {
					delete obj[2].children
				}
				this.result = JSON.stringify(obj);


				// 定义显示数据
				let newTxt = '';
				res.forEach((item, index) => {
					newTxt = newTxt + item.label;
				})
				// 定义显示地址
				_self.addssTxt = newTxt;
				_self.updateAddress.location = res[0].label;
				_self.updateAddress.locationyi = res[1].label;
				_self.updateAddress.locationer = res[2].label;
				// console.log('11111111111', res)
			},
			toCopy() {
				copy(copyText)
				this.$emit('tips')
			},
			
			// 评价订单
			evaluationOrder(item){
				let data = {
					pay:item.back_pay_type,
					time:item.back_create_time,
					order_id:item.order_id,
					num:item.back_num,
					name:item.goods_title,
					img:item.goods_img
				}
				_self.$router.push('/Evaluate?data='+encodeURIComponent(JSON.stringify(data)))
			}
		},
		destroyed() {
			//离开页面清楚定时器
			clearInterval(timer);
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// next();
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
		
	}
</script>
<style scoped>
	/* 物流信息 */
	.logisticsImg{
		margin-top: 20px;
		width: 100%;
		padding: 20px 30px 105px;
		box-sizing: border-box;
		background: #fff;
	}
	/* 物流信息进程 */
	.logisticsImgUl{
		width: 100%;
		margin-top: 25px;
		padding-left: 30px;
		box-sizing: border-box;
	}
	.logisticsImgUlLft p{
		font-size: 14px;
		font-weight: 400;
		text-align: center;
		color: #333333;
	}
	/* 竖线 */
	.logisticsImgUlCon{
		width: 25px;
		height: 25px;
		margin: 0 20px;
		position: relative;
	}
	.logisticsImgUlConP{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,0);
	}
	.logisticsImgUlConP img{
		width: 100%;
		height: 100%;
	}
	.logisticsImgUlConP span:nth-of-type(1){
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #a9a9a9;
		border-radius: 50%;
	}
	.logisticsImgUlConP span:nth-of-type(2){
		display: inline-block;
		margin-top: 1px;
		width: 1px;
		min-height: 55px;
		background: #a9a9a9;
	}
	/* 右 */
	.logisticsImgUlRgt{
		flex: 1;
		word-break: break-all;
		
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		color: #333333;
	}
	.orMarTop40{
		margin-top: 40px;
	}
	
	
	
	/* 物流信息图片 */
	.logisticsImgPone{
		font-size: 24px;
		font-weight: 400;
		text-align: left;
		color: #000000;
		letter-spacing: 3px;
	}
	.logisticsImgPtwo{
		padding-left: 30px;
		box-sizing: border-box;
		margin-top: 25px;
	}
	.logisticsImgPtwo img{
		width: 710px;
		height: 360px;
	}
	
	.main {
		width: 100%;
		padding-bottom: 40px;
		box-sizing: border-box;
		background: #f5f5f5;
		display: flex;
		flex-direction: column;
	}
	.main_nav {
		width: 1200px;
		margin: 0 auto;
	}
	.text {
		padding: 40px 0 35px 0;
		box-sizing: border-box;
		height: 24px;
		font-size: 18px;
		font-weight: 400;
		color: #999999;
		letter-spacing: 2px;
		display: flex;
		flex-direction: row;
	}
	.text li {
		margin-right: 10px;
	}
	.line {
		width: 1200px;
		height: 4px;
		background: #e62129;
	}
	/* 订单状态 */
	.statuslist {
		width: 1200px;
		background: #ffffff;
		margin-bottom: 20px;
	}
	.statuslist li {
		display: flex;
	}
	.left {
		width: 320px;
		height: 250px;
		border-right: 1px solid #cccccc;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
	}
	.right {
		width: 878px;
		height: 250px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		padding: 0 60px;
		box-sizing: border-box;
	}
	.oneright {
		width: 878px;
		height: 250px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 60px;
		box-sizing: border-box;
	}
	.oneright_nav {
		width: 878px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		margin-top: 30px;
		justify-content: center;
	}
	.proStatus {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		letter-spacing: 2px;
	}
	.proStatus img {
		display: block;
		width: 40px;
		height: 40px;
		margin-bottom: 20px;
	}
	.spot {
		width: 130px;
		height: 6px;
		display: block;
		margin: 0 10px;
	}
	.confirm {
		padding: 3px 22px;
		box-sizing: border-box;
		width: 120px;
		height: 28px;
		border: 1px solid #e62129;
		border-radius: 2px;
		color: #e62129;
		padding: 3px 40px;
		box-sizing: border-box;
	}
	.confirm_nav {
		padding: 3px 22px;
		box-sizing: border-box;
		width: 120px;
		height: 28px;
		border: 1px solid #e62129;
		border-radius: 2px;
		color: #e62129;
	}
	/* 产品信息 */
	.productlist {
		width: 1200px;
		padding: 20px 30px;
		box-sizing: border-box;
		background: #ffffff;
		margin-bottom: 20px;
	}
	.producttop {
		display: flex;
		flex-direction: column;
	}

	.proMenu {
		width: 100%;
		height: 44px;
		background-color: #F5F5F5;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 20px;
	}
	.proMenu1 {
			width: 100%;
			height: 44px;
			background-color: #F5F5F5;
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-top: 20px;
	}
	.proMenu li {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
		margin-left: 137px;
	}
	.proMenu li:nth-child(1){
		/* border: 1px solid red; */
		margin-left: 120px;
	}
	.proMenu1 li {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
		margin-left: 166px;
	}
	.proMenu1 li:nth-child(1){
		/* border: 1px solid red; */
		margin-left: 176px;
	}

	.proMenuList {
		display: flex;
		flex-direction: row;
		align-items: center;
		/* justify-content: space-around; */
		padding: 25px 0;
		box-sizing: border-box;
		border-bottom: 2px solid #F1F1F1;
		/* border: 1px solid red; */
	}

	.proMenuList li {
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		letter-spacing: 2px;
		/* border: 2px solid green; */
		
	}

	.firstLi {
		width: 280px;
		display: flex;
		flex-direction: row;
		align-items: center;
		/* border: 2px solid black; */
		margin-left: 15px;
	}
	.firstLi1 {
		width: 280px;
		display: flex;
		flex-direction: row;
		align-items: center;
		/* border: 2px solid black; */
		margin-left: 60px;
	}
	.num{
		width: 50px;
		text-align: center;
		margin-left: 45px;
	}
	.num1{
		width: 50px;
		text-align: center;
		margin-left: 85px;
	}
	.orderNum{
		width: 140px;
		text-align: center;
		margin-left: 120px;
	}
	.orderNum1{
		width: 140px;
		text-align: center;
		margin-left: 150px;
	}
	.createTime{
		width: 200px;
		text-align: center;
		margin-left: 45px;
	}
	.createTime1{
		width: 200px;
		text-align: center;
		margin-left: 65px;
	}
	.payType{
		width: 80px;
		text-align: center;
		margin-left: 60px;
	}

	.firstLi img {
		width: 60px;
		height: 60px;
		display: flex;
		margin-right: 10px;
	}
	.firstLi1 img {
		width: 60px;
		height: 60px;
		display: flex;
		margin-right: 10px;
	}
	

	.proDetailNav {
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		letter-spacing: 2px;
		flex: 1;
	}

	.productbot {
		display: flex;
		flex-direction: column;
		padding-top: 20px;
		box-sizing: border-box;
	}

	.productbot li {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
		margin-bottom: 10px;
	}

	/* 收货人信息 */
	.memberlist {
		width: 1200px;
		background: #ffffff;
		display: flex;
		flex-direction: column;
		padding: 20px 30px;
		box-sizing: border-box;
		overflow: hidden;
	}

	.memberlist p {
		font-size: 24px;
		font-weight: 400;
		color: #000000;
		letter-spacing: 3px;
	}

	.memberlist_nav {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-top: 30px;
	}

	.memberlist_nav li {
		font-size: 20px;
		font-weight: 400;
		color: #000000;
		letter-spacing: 2px;

	}

	.memberlist_nav li:nth-child(1) {
		width: 275px;
	}

	.memberlist_nav li:nth-child(2) {
		width: 363px;
	}

	.memberlist_nav li:nth-child(3) {
		flex: 1;
	}

	.address {
		margin-top: 20px;
	}

	/* 修改地址弹框 */
	.Maddress {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2010;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
	}

	.Maddress_nav {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 830px;
		height: 653px;
		background: #ffffff;
		padding: 30px 30px;
		box-sizing: border-box;
	}

	.Maddress_nav_top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		font-size: 24px;
		font-weight: 400;
		color: #000000;
		letter-spacing: 3px;
	}

	.Maddress_nav_top img {
		width: 20px;
		height: 20px;
		display: block;
	}

	.addDetail {
		width: 620px;
		margin: 0 80px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.li_top {
		width: 100%;
		height: 44px;
		background: #f1f1f1;
		padding: 11px 30px;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
	}

	.form {
		width: 580px;
		padding: 20px 0;
		box-sizing: border-box;
	}

	.form li {
		width: 580px;
		height: 44px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		color: #666666;
		letter-spacing: 2px;
		padding: 20px 20px;
		box-sizing: border-box;
		margin-bottom: 20px;
	}

	.lastli {
		display: flex;
		flex-direction: row;
		padding: 0 126px;
		box-sizing: border-box;
	}

	.form li p {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.alert {
		width: 430px;
		height: 44px;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 2px;
		color: #999999;
		font-size: 16px;
		padding: 11px 15px;
		box-sizing: border-box;
	}

	.form li input {
		width: 430px;
		height: 44px;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 2px;
		color: #999999;
		font-size: 16px;
		padding: 11px 15px;
		box-sizing: border-box;
	}

	.form li textarea {
		width: 430px;
		height: 62px;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 2px;
		color: #999999;
		font-size: 16px;
		padding: 10px 15px;
		box-sizing: border-box;
	}

	.choice {
		width: 24px;
		height: 24px;
		background: #ffffff;
		border: 1px solid #cccccc;
	}

	button {
		width: 72px;
		height: 30px;
		background: #3239ff;
		font-size: 14px;
		font-weight: 400;
		color: #ffffff;
		letter-spacing: 1px;
		margin: 30px 126px;
		box-sizing: border-box;
	}

	.mtitle {
		font-size: 16px;
		color: #ff6e00;
		margin: 40px 60px 15px 60px;
	}

	.minput {
		font-size: 16px;
		color: #FF0000;
	}

	.mselect {
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		margin-left: 10px;
	}

	.li_top_add {
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		margin-left: 20px;
	}

	.waitPay {
		margin-bottom: 15px;
		font-size: 28px;
		font-weight: 700;
		color: #e62129;
		letter-spacing: 3px;
	}

	.countDown {
		font-size: 18px;
		color: #e62129;
		margin-bottom: 25px;
	}

	.editAdd {
		font-size: 16px;
		color: #666666;
		margin: 10px 0;
	}

	.cancelOrder {
		font-size: 16px;
		color: #666666;
	}

	.oneright_top {
		font-size: 14px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
		margin: 15px 0;
	}

	.nine {
		color: #999999;
	}

	.productbot_last {
		font-size: 16px;
		font-weight: 700;
		color: #e62129 !important;
		letter-spacing: 2px;
	}
	
	.rgtTxtMinWid{
		min-width: 120px !important;
		font-size: 16px;
		font-weight: 400;
		text-align: right;
		letter-spacing: 2px;
	}
	.evaluation-order{
		font-size: 14px;
		font-weight: 400;
		color: #e62129;
		letter-spacing: 2px;
		width: 80px;
		height: 24px;
		border: 1px solid #e62129;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 15px 0;
	}
</style>
